import { FormInstance, message } from 'antd';
import { TAG_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { TagInterface } from 'type/tagType';

class TagService {
  constructor(private apiService: ApiService<TagInterface>) {}

  public async createTag(
    form: FormInstance,
    customData?: Partial<TagInterface>
  ): Promise<TagInterface> {
    try {
      const tag = { ...form.getFieldsValue(), ...customData };
      // Legacy name field: use lowercase if it exists
      if (tag.name) {
        tag.name = tag.name.toLowerCase();
      }
      // If i18n_name exists but name doesn't, use i18n_name.ko
      if (tag.i18n_name?.ko && !tag.name) {
        tag.name = tag.i18n_name.ko.toLowerCase();
      }
      // Ensure i18n fields are included even if they're empty objects
      if (!tag.i18n_name) {
        tag.i18n_name = {};
      }
      if (!tag.i18n_description) {
        tag.i18n_description = {};
      }
      return await this.apiService.create(tag);
    } catch (error) {
      message.error('Failed to create : ' + error);
      throw error;
    }
  }

  public async updateTag(
    id: number,
    form: FormInstance,
    customData?: Partial<TagInterface>
  ): Promise<TagInterface> {
    try {
      const tag = { ...form.getFieldsValue(), ...customData };
      // Legacy name field: use lowercase if it exists
      if (tag.name) {
        tag.name = tag.name.toLowerCase();
      }
      // If i18n_name exists but name doesn't, use i18n_name.ko
      if (tag.i18n_name?.ko && !tag.name) {
        tag.name = tag.i18n_name.ko.toLowerCase();
      }
      // Ensure i18n fields are included even if they're empty objects
      if (!tag.i18n_name) {
        tag.i18n_name = {};
      }
      if (!tag.i18n_description) {
        tag.i18n_description = {};
      }
      return await this.apiService.update(id, tag);
    } catch (error) {
      message.error('Failed to update : ' + error);
      throw error;
    }
  }
}

export const tagService = new TagService(new ApiService(TAG_API_PATH));
